// src/mocks/handlers/clients.handlers.js
import * as data from '../data/clients.demo';

export const handle = async (config) => {
    if (config.method === 'post') return { success: true, data: {} };
    if (config.method === 'put') return { success: true, data: {} };
    if (/\/clients\/\d+/.test(config.url)) return data.clientList.clients[0] || {};
    return data.clientList;
};

export const searchByName = async () => data.clientSearchResults;
export const searchByCuit = async () => null;
export const validateCuit = async () => data.cuitValidation;
export const save = async () => ({ success: true, data: {} });
